import { Container } from '@refactco/ui-kit';

const Layout = ( { children } ) => {
	return (
		<>
			<Container>{ children }</Container>
		</>
	);
};

export default Layout;
